<template>
  <div style="width: 100%">
    <v-combobox
      v-if="$store.state.mobileMode"
      :menu-props="{ contentClass: 'forceLeftCbo' }"
      v-model="cboCity"
      :items="cboCities"
      hide-selected
      placeholder="Todas as campanhas"
      @change="filterCampaignsMobile"
    ></v-combobox>
    <v-breadcrumbs :items="ufs" divider=" - " v-if="!$store.state.mobileMode">
      <!-- <v-breadcrumbs-item
        style="cursor: pointer; text-decoration:  nderline"
        slot="item"
        slot-scope="{ item }"
        @click="filterByCity(item.text)"
      > -->
      <v-breadcrumbs-item
        style="cursor: pointer; text-decoration: underline"
        slot="item"
        slot-scope="{ item }"
        @click="filterByCity(item.text, item)"
        :class="[item.sel ? 'font-weight-black vermelho_corpore--text' : '']"
      >
        <!-- $store.state.mobileMode ? 'px-4 mb-5' : '', -->
        {{ item.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <!-- <div class="mx-15 px-15">
      <v-alert class="mx-15" v-if="!campaigns.length" dense text type="success">
        Não existem campanhas cadastradas
      </v-alert>
    </div> -->

    <v-row no-gutters class="mt-5">
      <v-col
        v-for="(campaign, index) in campaigns"
        :key="index"
        :class="[$store.state.mobileMode ? '' : 'px-15', 'mt-5 mb-10']"
        cols="12"
        sm="6"
      >
        <h3 class="h3 text-left mb-3">{{ campaign.title }}</h3>
        <v-img max-width="550" width="auto" :src="campaign.image"></v-img>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getCampaigns("");
    this.getCities();
  },
  methods: {
    getCities() {
      var obj = {
        url: "/api/getCities",
        query: {
          type: "campaign",
          filter: "",
        },
        method: "get",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        console.log(response.data);
        this.cboCities = [...response.data];
        this.cboCities.unshift("Todas as campanhas");
        this.ufs = [
          ...response.data.map((cty) => {
            return {
              text: cty,
              disabled: false,
              sel: false,
            };
          }),
        ];
        //this.campaigns = [...response.data.data];
      });
    },
    filterCampaignsMobile() {
      if (this.cboCity == "Todas as campanhas") {
        this.getCampaigns("");
      } else {
        this.getCampaigns(this.cboCity);
      }
    },
    getCampaigns(filter) {
      var obj = {
        url: "/api/cfc/listCfc",
        query: {
          type: "campaign",
          filter: filter,
        },
        method: "post",
      };
      //console.log("site camp");
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        // console.log(response);
        this.campaigns = [...response.data.data];
      });
    },
    filterByCity(city, item) {
      console.log(city);
      this.ufs.map((op) => {
        op.sel = false;
        return op;
      });
      //console.log(item);
      if (this.selectedCity == city) {
        this.selectedCity = "";
        item.sel = false;
        this.getCampaigns("");
        return;
      }
      this.getCampaigns(city);
      item.sel = true;
      this.selectedCity = city;
    },
  },
  data() {
    return {
      selectedCity: "",
      campaigns: [],
      ufs: [],
      cboCity: "",
      cboCities: [],
    };
  },
};
</script>

<style>
</style>